// 알람 조건
export function convertType(type){
    if(type == 'UP'){
        return "이상"
    }else if(type=="DOWN"){
        return "이하"
    }else if(type == "LIMIT"){
        return "지정가 돌파"
    }
}

// 알람 퍼센트
export function convertPercent(percent){
    if(percent ==null ){ // 기본값(선택안했을떄)
        return null
    }else { // 설정금액도 같이 계산
        return `${percent}%`
    }
}

// 알람 주기
export function convertCycle(cycle){
    if(cycle == "ONCE"){
        return "한번만"
    }else if(cycle == "DAY_1"){
        return "하루 마다"
    }else if(cycle.split("_")[0] == "MINUTE"){
        return `${cycle.split("_")[1]}분마다`
    }else if(cycle.split("_")[0] == "HOUR"){
        return `${cycle.split("_")[1]}시간 마다`
    }
}

export function convertSoundId(sound){
    if(sound ==1){
        return '알람음 선택'
    }else if(sound >0 && sound !=1){
        return `Sound ${sound}`
    }else {
        return null
    }
}